/* import __COLOCATED_TEMPLATE__ from './standing-out.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type { CxBenchmarkGroup } from './types';

type Sentiment = 'positive' | 'neutral' | 'negative';

interface StandingOutItem {
  label: string;
  difference: string;
  sentiment: Sentiment;
  dotColorClass: string;
  textColorClass: string;
}

const DOT_COLOR_MAP: Record<Sentiment, string> = {
  positive: 'bg-success-fill',
  neutral: 'bg-neutral-border-emphasis',
  negative: 'bg-error-fill',
};

const TEXT_COLOR_MAP: Record<Sentiment, string> = {
  positive: 'text-success',
  neutral: 'text-default',
  negative: 'text-error',
};

interface Signature {
  Args: {
    benchmarkGroup: CxBenchmarkGroup | undefined;
  };
}

export default class StandingOut extends Component<Signature> {
  @service declare intl: IntlService;

  // TODO: Compute from real benchmark data comparison
  get items(): StandingOutItem[] {
    let rawItems: Omit<StandingOutItem, 'dotColorClass' | 'textColorClass'>[] = [
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.standing-out.label-fin-answer-quality',
        ),
        difference: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.standing-out.difference-fin-answer-quality',
        ),
        sentiment: 'positive',
      },
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.standing-out.label-informational-queries',
        ),
        difference: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.standing-out.difference-informational-queries',
        ),
        sentiment: 'neutral',
      },
      {
        label: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.standing-out.label-negative-feedback',
        ),
        difference: this.intl.t(
          'components.reporting.bespoke.fin-performance.cx-benchmark-panel.standing-out.difference-negative-feedback',
        ),
        sentiment: 'positive',
      },
    ];
    return rawItems.map((item) => ({
      ...item,
      dotColorClass: DOT_COLOR_MAP[item.sentiment],
      textColorClass: TEXT_COLOR_MAP[item.sentiment],
    }));
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Bespoke::FinPerformance::CxBenchmarkPanel::StandingOut': typeof StandingOut;
    'reporting/bespoke/fin-performance/cx-benchmark-panel/standing-out': typeof StandingOut;
  }
}
